import { render, staticRenderFns } from "./Wais4.vue?vue&type=template&id=4d67e837&lang=true"
import script from "./Wais4.vue?vue&type=script&lang=js"
export * from "./Wais4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports